<template>
    <div>
        <div class="back-arrow" @click="$emit('cancel')">
            <a href="#"><img src="../../assets/ic_back.png"></a>
        </div>
        <div class="tile">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs addstyle" role="tablist">
                <li :class="{active: activeTab === 'tanach_tab'}" @click="activeTab = 'tanach_tab'" role="presentation"><a href="#" aria-controls="home" role="tab"><h3>Tanach</h3></a></li>
                <li :class="{active: activeTab === 'favorites_tab'}" @click="activeTab = 'favorites_tab'" role="presentation"><a href="#" aria-controls="profile" role="tab"><h3>Favorites</h3></a></li>
                <li :class="{active: activeTab === 'recent_tab'}" @click="activeTab = 'recent_tab'" role="presentation" class=""><a href="#" aria-controls="messages" role="tab"><h3>Recent</h3></a></li>
            </ul>
            <!-- Tab panes -->
            <div class="tab-content tab-content2">
                <div role="tabpanel" class="tab-pane" :class="{active: activeTab === 'tanach_tab'}" id="home">
                    <ul class="mynav">
                        <li>
                            <ul>
                                <li v-for="(crumb, index) in selectionObject.breadCrumbs" :key="index" @click="selectionObject.selectCrumb(index)"><a>{{ crumb.title }}</a></li>
                            </ul>
                        </li>
                    </ul>
                    <div class="row no-gutters row-eq-height">
                        <div class="col-xs-3 side">
                            <div class="baron" dir="rtl" style="text-align: left">
                                <div class="scrollable25 baron__scroller">
                                    <ul class="control-group check">
                                        <li class="selectall">
                                            <label class="control control--checkbox">
                                                <div class="chek-box-holder">
                                                    <input type="checkbox"
                                                           @click="selectionObject.toggleAll()"
                                                           :checked="selectionObject.areAllChecked()">
                                                    <div class="control__indicator"></div>
                                                </div>
                                                <p class="black">Select All</p>
                                            </label>
                                        </li>
                                        <ul id="genesis">
                                            <li v-for="(child, index) in selectionObject.treeItems" :key="index">
                                                <label id="showtxt"
                                                       class="control control--checkbox"
                                                       :class="{uncheck: child.isItemPartial()}">
                                                    <div class="chek-box-holder">
                                                        <input type="checkbox"
                                                               @click="child.toggleSelection()"
                                                               :checked="child.isItemSelected()"
                                                               :indeterminate.prop="child.isItemPartial()">
                                                        <div class="control__indicator"></div>
                                                    </div>
                                                    <p>{{ child.title.replace('Pasuk', 'Verse') }}</p>
                                                </label>
                                                <div class="after"
                                                     :class="{myclass: home}"
                                                     v-if="!child.isItemLeaf()"
                                                     @click="child.expandItem()"></div>
                                            </li>
                                        </ul>
                                    </ul>
                                </div>
                                <div class="baron__track">
                                    <div class="baron__bar"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-9">
                            <div class="baron mybaron">
                                <div class="scrollable25 baron__scroller">
                                    <div class="frame" v-if="previewText.length === 0 && !selectionObject.previewLoading">
                                        <div class="img-holder second-img">
                                            <img v-if="type === 'text'" class="microscope" src="../../assets/Microscope-Outline.png">
                                            <img v-if="type === 'class'" class="lowercase" src="../../assets/Lowercase-Outline.png">
                                            <!--<span class="counter">1</span>-->
                                        </div>
                                        <p> Select your text. You may select multiple texts, even if they are not continuous.
                                            <br /><span v-if="false"
                                                style="font-size: inherit;">(Your entire selection must total at least 200 verses.)
                                                <br /></span>When done, click “Select Text”</p>
                                    </div>
                                    <div class="block">
                                        <span v-if="selectionObject.previewLoading"><spinner></spinner></span>
                                        <div v-else class="verses-list">
                                            <div v-for="chunk in arrangedPreviewText" :key="chunk.chunkID">
                                                <p>
                                                    <span class="indenter"></span>
                                                    <strong>{{ getChunkHeader(chunk) }}</strong>
                                                </p>
                                                <ul>
                                                    <li v-for="pasuk in chunk.pesukim" :key="pasuk.chunkKey">
                                                        <a href="#">
                                                            <em class="first-word">{{ pasukHeb(pasuk.chunkKey) }}</em>
                                                            <span>
                                                             {{ pasuk.text }}
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-if="previewTextTruncated">...</div>
                                        </div>
                                    </div>
                                    <div class="empty-class"></div>
                                </div>
                                <div class="baron__track">
                                    <div class="baron__bar"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-footer fixed-height-tab-footer">
                        <button @click="$emit('select', { oldText: text, newText: selectionObject.text})" type="button" class="button lg bg-gray pull-right hoverable"><div class="anim"></div>Select Text</button>
                        <div class="footer-txt">
                            <p>{{ selectionObject.summarizeText() }}</p>
                        </div>
                    </div>
                </div>
                <div role="tabpanel" class="tab-pane" :class="{active: activeTab === 'favorites_tab'}">
                    <div class="row no-gutters row-eq-height">
                        <div class="col-xs-12">
                            <div class="baron">
                                <div class="scrollable25 baron__scroller">
                                    <div v-if="!$store.state.isLoggedIn" class="text-frame">
                                        <h3>To See Favorites Classes, you must<br> <a class="blue" href="#" @click="closeAndLogin">Sign in</a> or <a class="blue" href="#" @click="closeAndLogin">Sign up</a></h3>
                                    </div>
                                    <ul v-else id="addlist" class="list">
                                        <li>
                                            <div class="row">
                                                <div class="col-xs-8">
                                                    <ul class="control-group check save">
                                                        <li>
                                                            <label class="control control--radio">
                                                                <div style="visibility: hidden;" class="chek-box-holder">
                                                                    <input type="checkbox">
                                                                    <div class="control__indicator"></div>
                                                                </div>
                                                                <p>Name</p>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-xs-2">
                                                    <p>Last usage type</p>
                                                </div>
                                                <div class="col-xs-2">
                                                    <p>Date created</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li v-for="(saveItem, index) in $store.state.favorites" :key="index">
                                            <div class="row">
                                                <div class="col-xs-8">
                                                    <ul class="control-group check save">
                                                        <li>
                                                            <label class="control control--radio">
                                                                <div class="chek-box-holder">
                                                                    <input type="radio" v-model="selectedFavorite" :value="saveItem">
                                                                    <div class="control__indicator"></div>
                                                                </div>
                                                                <p>{{saveItem.name}}</p>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-xs-2">
                                                    <button type="button" class="bt sm bg-light-gray no-pointer">{{saveItem.context}}</button>
                                                </div>
                                                <div class="col-xs-2">
                                                    <p class="mytitle">{{new Date(saveItem.date).toLocaleDateString()}}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="empty-class"></li>
                                    </ul>
                                </div>
                                <div class="baron__track">
                                    <div class="baron__bar"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-footer">
                        <button @click="sendSelectSavedItemEvent(selectedFavorite)" type="button" class="button lg bg-gray pull-right hoverable"><div class="anim"></div>Select Text</button>
                    </div>
                </div>
                <div role="tabpanel" class="tab-pane" :class="{active: activeTab === 'recent_tab'}" id="messages">

                    <div class="row no-gutters row-eq-height">
                        <div class="col-xs-12">
                            <div class="baron">
                                <div class="scrollable25 baron__scroller">
                                    <div v-if="!$store.state.isLoggedIn" class="text-frame">
                                        <h3>To See Recent Classes, you must<br> <a class="blue" href="#" @click="closeAndLogin">Sign in</a> or <a class="blue" href="#" @click="closeAndLogin">Sign up</a></h3>
                                    </div>
                                    <ul v-else class="list">
                                        <li>
                                            <div class="row">
                                                <div class="col-xs-8">
                                                    <ul class="control-group check save">
                                                        <li>
                                                            <label class="control control--radio" style="cursor: text">
                                                                <div style="visibility: hidden;" class="chek-box-holder">
                                                                    <input type="checkbox">
                                                                    <div class="control__indicator"></div>
                                                                </div>
                                                                <p>Name</p>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-xs-2">
                                                    <p>Last usage type</p>
                                                </div>
                                                <div class="col-xs-2">
                                                    <p>Date created</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li v-for="(saveItem, index) in $store.state.recent" :key="index">
                                            <div class="row">
                                                <div class="col-xs-8">
                                                    <ul class="control-group check save">
                                                        <li>
                                                            <label class="control control--radio">
                                                                <div class="chek-box-holder">
                                                                    <input type="radio" v-model="selectedRecent" :value="saveItem">
                                                                    <div class="control__indicator"></div>
                                                                </div>
                                                                <p>{{saveItem.name}}</p>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-xs-2">
                                                    <button type="button" class="bt sm bg-light-gray no-pointer">{{saveItem.context}}</button>
                                                </div>
                                                <div class="col-xs-2">
                                                    <p class="mytitle">{{new Date(saveItem.date).toLocaleDateString()}}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="empty-class"></li>
                                    </ul>
                                </div>
                                <div class="baron__track">
                                    <div class="baron__bar"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-footer">
                        <button @click="sendSelectSavedItemEvent(selectedRecent)" type="button" class="button lg bg-gray pull-right hoverable"><div class="anim"></div>Select Text</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import Spinner from '../spinner'
import treeService from '../../texts/treeService'
import {Text} from '../../texts'

function numToHebrew (num) {
  const ones = num % 10
  const tens = (num - ones) / 10 % 10
  const hundreds = (num - tens * 10 - ones) / 100
  let result = ''
  if (hundreds) { result = 'dקרשת'[hundreds] }
  if (tens === 1 && ones === 5) {
    result += 'טו'
  } else if (tens === 1 && ones === 6) {
    result += 'טז'
  } else result += (tens ? 'dיכלמנסעפצ'[tens] : '') + (ones ? 'dאבגדהוזחט'[ones] : '')
  return result
};

function bookChapterAndVerse (key) {
  let matches = /\/Tanakh\/[^/]*\/([^/]*)?(?:\/Chapter ([^/]*))?(?:\/Pasuk (.*))?/.exec(key)
  if (!matches) {
    // (old version) return _.drop(/Tanakh\/([^/]*)/.exec(key))
    console.log('key:')
    console.log(key)
    return []
  }
  matches.shift()
  return _.compact(matches)
}

export default {
  name: 'selectTextPopup',
  components: {Spinner},
  props: ['text', 'type'],
  data () {
    return {
      selectionObject: treeService.getSelectionObject(),
      activeTab: 'tanach_tab',
      home: false,
      signup: false,
      selectedFavorite: null,
      selectedRecent: null
    }
  },
  computed: {
    previewText: function () {
      const firstTen = _.take(this.selectionObject.previewText, 10)
      const contents = _.flatten(firstTen.map(unit => unit.contents))
      return contents.map((smallUnit, index) => smallUnit.smallUnit ? smallUnit.smallUnit : { chunkKey: index, text: '' })
    },
    previewTextTruncated () {
      return this.selectionObject.previewText && this.selectionObject.previewText.length > 10
    },
    arrangedPreviewText: function () {
      const flat = this.previewText
      if (!flat || flat.length === 0) {
        return
      }
      let chunks = []
      let pesukim = []
      let chunkID = ''
      let lastValid = ['not yet']
      for (let i = 0; i < flat.length; i++) {
        let nextPasuk = flat[i]
        let indices = bookChapterAndVerse(nextPasuk.chunkKey)
        if (i === 0) {
          chunkID = nextPasuk.chunkKey
          pesukim.push(nextPasuk)
        } else {
          if (indices[0] === lastValid[0] && indices[1] === lastValid[1]) {
            pesukim.push(nextPasuk)
          } else if (indices.length !== 0) {
            chunks.push({'chunkID': chunkID, 'pesukim': pesukim})
            pesukim = [nextPasuk]
            chunkID = nextPasuk.chunkKey
          }
        }
        if (indices.length > 0) { lastValid = indices }
      }
      if (pesukim !== []) { chunks.push({'chunkID': chunkID, 'pesukim': pesukim}) }
      return chunks
    }
  },
  methods: {
    pasukNum: function (key) {
      return bookChapterAndVerse(key)[2]
    },
    pasukHeb: function (key) {
      return numToHebrew(this.pasukNum(key))
    },
    chapterNum: function (key) {
      return bookChapterAndVerse(key)[1]
    },
    chapterHeb: function (key) {
      return numToHebrew(this.chapterNum(key))
    },
    getChunkHeader: function (chunk) {
      let firstKey = chunk.chunkID
      if (firstKey === '') {
        return 'ספר ופרק לא רשומים כמו שצריך'
      } else {
        return bookChapterAndVerse(firstKey)[0] + ' ' + this.chapterNum(firstKey)
      }
    },
    sendSelectSavedItemEvent (saveItem) {
      this.activeTab = 'tanach_tab'
      if (saveItem) {
        this.$emit('select', {oldText: this.text, newText: new Text(saveItem.text.keys, saveItem.text.name)})
      }
    },
    closeAndLogin () {
      this.$emit('cancel')
      this.$store.commit('LOGIN_REQUESTED')
    }
  },
  watch: {
    text: {
      handler () {
        this.selectionObject.initializeFromText(this.text)
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.indenter {
  display: inline-block;
  width: 5%;
}
.no-pointer {
  cursor: initial;
}
.mynav ul li:last-child a {
  cursor: initial;
}
.fixed-height-tab-footer {
  height: 78px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/experiment/selectTextPopup.vue